import React from 'react';



class RequestVerificationCodeCommand extends React.Component {
    render() {
        let button = null;
        if (this.props.operationInProgress) {
            button =
                <button className="btn btn-primary btn-block mb-2 mb-sm-0" type="button" disabled>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    &nbsp;&nbsp;{this.props.sendingVerificationCodeLocalizedString}
                </button>;
        }
        else {
            button =
                <button className="btn btn-primary btn-block mb-2 mb-sm-0" type="button"
                    onClick={this.props.onClickRequestVerificationCode}>
                    {this.props.sendVerificationCodeLocalizedString}
                </button>
        }
        return (
            <div>
                {button}
            </div>
        );
    }
}
export default RequestVerificationCodeCommand;


